const isScrolledIntoView = (el, visibilityRatio) => {
  const rect = el.getBoundingClientRect();
  const elemTop = rect.top;
  const elemBottom = rect.bottom;
  const elemHeight = rect.height;
  const isVisible = (elemTop <= window.innerHeight // eslint-disable-line no-undef
  - elemHeight * visibilityRatio)
  && (elemBottom >= elemHeight * visibilityRatio);
  return isVisible;
};

export default isScrolledIntoView;
